import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import CONSTANTS from "../utils/constants";
import { useNavigate } from "react-router-dom";
import ProductsPagination from "./Pagination";
import { useTranslation } from "react-i18next";

const paymentMapping = {
  nagt: "nagt",
  наличными: "nagt",
  cash: "nagt",
  kart: "kart",
  карточкой: "kart",
  карта: "kart",
  card: "kart",
  terminal: "kart",
  online: "online",
  онлайн: "online",
};

const statusMapping = {
  Garaşylýar: "garasylyar",
  "В ожидании": "garasylyar",
  "Kabul edilen": "kabul_edilen",
  Принято: "kabul_edilen",
  "Iberildi ýolda": "iberildi_yolda",
  "В пути": "iberildi_yolda",
  Tamamlandy: "tamamlandy",
  Завершено: "tamamlandy",
  "Ret edilen": "ret_edilen",
  Отклонено: "ret_edilen",
};

// fixedStatus locks the page to a single status (used by the dedicated
// "Tamamlanan sargytlar" / "Ret edilen sargytlar" routes) — no dropdown, no
// shared cookie, so it can never leak into or get overwritten by the plain
// "Sargytlar" view's own remembered filter.
export default function AdminOrders({ fixedStatus }) {
  const { t } = useTranslation();
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [status, setStatus] = useState(fixedStatus || "");
  const [region, setRegion] = useState("");
  const [city, setCity] = useState("");
  const [time, setTime] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [locations, setLocations] = useState([]);
  const [viewMode, setViewMode] = useState("card");

  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(16);
  const navigate = useNavigate();
const [orderTimesList, setOrderTimesList] = useState([]);

useEffect(() => {
  const fetchData = async () => {
    try {
      const [ordersRes, locRes, timesRes] = await Promise.all([
        axios.get(`${CONSTANTS.baseRoute}/orders`),
        axios.get(`${CONSTANTS.baseRoute}/locations-price`),
        axios.get(`${CONSTANTS.baseRoute}/order/times`),
      ]);
      setOrders(ordersRes.data);
      setLocations(locRes.data);
      setOrderTimesList(timesRes.data);
    } catch (err) {
      console.error(err);
    }
  };
  fetchData();
}, []);
  

  useEffect(() => {
    setSearchTerm(Cookies.get("adminOrders_searchTerm") || "");
    setPaymentMethod(Cookies.get("adminOrders_paymentMethod") || "");
    // A fixedStatus page (the dedicated completed/rejected routes) never
    // reads or writes the shared status cookie — it would otherwise leak
    // into, or get overwritten by, the plain "Sargytlar" view.
    setStatus(fixedStatus || Cookies.get("adminOrders_status") || "");
    setRegion(Cookies.get("adminOrders_region") || "");
    setCity(Cookies.get("adminOrders_city") || "");
    setTime(Cookies.get("adminOrders_time") || "");
    setStartDate(Cookies.get("adminOrders_startDate") || "");
    setEndDate(Cookies.get("adminOrders_endDate") || "");
  }, [fixedStatus]);

  useEffect(() => {
    Cookies.set("adminOrders_searchTerm", searchTerm);
  }, [searchTerm]);
  useEffect(() => {
    Cookies.set("adminOrders_paymentMethod", paymentMethod);
  }, [paymentMethod]);
  useEffect(() => {
    if (!fixedStatus) Cookies.set("adminOrders_status", status);
  }, [status, fixedStatus]);
  useEffect(() => {
    Cookies.set("adminOrders_region", region);
  }, [region]);
  useEffect(() => {
    Cookies.set("adminOrders_city", city);
  }, [city]);
  useEffect(() => {
    Cookies.set("adminOrders_time", time);
  }, [time]);
  useEffect(() => {
    Cookies.set("adminOrders_startDate", startDate);
  }, [startDate]);
  useEffect(() => {
    Cookies.set("adminOrders_endDate", endDate);
  }, [endDate]);


const formattedOrderTimes = useMemo(() => {
  return orderTimesList
    .filter(t => t.is_active) // Sadece aktif olanları göster
    .map(t => {
      // time_from: "09:00:00" -> "09:00"
      const from = t.time_from.slice(0, 5);
      const to = t.time_to.slice(0, 5);
      return `${from} - ${to}`;
    })
    .sort();
}, [orderTimesList]);

  const uniqueTimes = useMemo(() => {
    const timeMap = new Map();
    orders.forEach((o) => {
      if (o.time) {
        const fullTime = o.time; // "2026-01-09 13:00 - 15:00"
        const timeMatch = fullTime.match(/(\d{4}-\d{2}-\d{2}) (.*)/);
        const displayTime = timeMatch ? timeMatch[2] : fullTime; // "13:00 - 15:00"
        if (!timeMap.has(fullTime)) {
          timeMap.set(fullTime, displayTime);
        }
      }
    });
    return Array.from(timeMap.entries()).sort((a, b) =>
      a[1].localeCompare(b[1])
    );
  }, [orders]);

  const cityNameToId = useMemo(() => {
    const map = new Map();
    locations.forEach((l) => map.set(l.city_tm, l.city_id));
    return map;
  }, [locations]);

  const uniqueRegions = useMemo(
    () => Array.from(new Set(locations.map((l) => l.region_tm))).sort(),
    [locations]
  );

  const filteredCities = useMemo(() => {
    const source = region
      ? locations.filter((l) => l.region_tm === region)
      : locations;
    return Array.from(new Set(source.map((l) => l.city_tm))).sort();
  }, [region, locations]);

  // ✅ ANA FİLTRELEME MANTIĞI
  useEffect(() => {
    let filtered = [...orders];

    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter(
        (o) =>
          o.id.toString().includes(lower) ||
          o.phone_number?.toString().includes(lower)
      );
    }

    if (paymentMethod) {
      const selectedFilter = paymentMethod.toLowerCase();
      filtered = filtered.filter(
        (o) =>
          paymentMapping[o.payment_method?.toLowerCase()] === selectedFilter
      );
    }

    if (status) {
      const selectedStatusKey = statusMapping[status] || status;
      filtered = filtered.filter(
        (o) => statusMapping[o.status] === selectedStatusKey
      );
    } else {
      // Default "Sargytlar" view (no status picked) — completed/rejected
      // orders have their own dedicated sidebar shortcuts now, so keep them
      // out of the general list.
      filtered = filtered.filter(
        (o) => o.status !== "Tamamlandy" && o.status !== "Ret edilen"
      );
    }

    if (region) filtered = filtered.filter((o) => o.region === region);

    if (city) {
      const cityId = cityNameToId.get(city);
      if (cityId) filtered = filtered.filter((o) => o.city === cityId);
    }

if (time) {
  filtered = filtered.filter((o) => 
    o.time && o.time.includes(time) 
  );
}

    if (startDate)
      filtered = filtered.filter(
        (o) => new Date(o.created_at) >= new Date(startDate)
      );

    if (endDate) {
      const end = new Date(endDate);
      end.setHours(23, 59, 59);
      filtered = filtered.filter((o) => new Date(o.created_at) <= end);
    }

    const statusOrder = {
      Garaşylýar: 1,
      "Kabul edilen": 2,
      "Iberildi ýolda": 3,
      Tamamlandy: 4,
      "Ret edilen": 5,
    };
    filtered.sort(
      (a, b) =>
        (statusOrder[a.status] || 6) - (statusOrder[b.status] || 6) ||
        b.id - a.id
    );

    setFilteredOrders(filtered);
    setCurrentPage(1);
  }, [
    orders,
    searchTerm,
    paymentMethod,
    status,
    region,
    city,
    time,
    startDate,
    endDate,
    cityNameToId,
  ]);

  const getPaymentDisplay = (method) =>
    t(paymentMapping[method?.toLowerCase()] || method);
  const getStatusDisplay = (st) => t(statusMapping[st] || st);
  const getStatusColor = (st) => {
    const colors = {
      Garaşylýar: "bg-order",
      "Kabul edilen": "bg-yellow",
      "Iberildi ýolda": "bg-blue",
      Tamamlandy: "bg-green",
      "Ret edilen": "bg-red",
    };
    return colors[st] || "";
  };
  const formatDateTime = (dateString) => new Date(dateString).toLocaleString();

  const handleClear = () => {
    setSearchTerm("");
    setPaymentMethod("");
    setStatus("");
    setRegion("");
    setCity("");
    setTime("");
    setStartDate("");
    setEndDate("");
    Object.keys(Cookies.get()).forEach((cookieName) => {
      if (cookieName.startsWith("adminOrders_")) Cookies.remove(cookieName);
    });
  };

  const currentOrders = filteredOrders.slice(
    (currentPage - 1) * ordersPerPage,
    currentPage * ordersPerPage
  );

  return (
    <div className="admin-main p-2">
      <div className="d-flex gap-2 align-items-center mb-2">
        <button className="btn admin-icon-btn" onClick={() => navigate(-1)}>
          <i className="bi bi-chevron-left"></i>
        </button>
        <button className="btn admin-icon-btn" onClick={() => navigate(+1)}>
          <i className="bi bi-chevron-right"></i>
        </button>
        <h5 className="mb-0 fw-bold">
          {fixedStatus === "Tamamlandy"
            ? t("tamamlanan_sargytlar")
            : fixedStatus === "Ret edilen"
            ? t("ret_edilen_sargytlar")
            : t("sargytlar")}
        </h5>
      </div>

      <div className="card p-2">
        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 mb-2 gy-2">
          <div className="col d-flex align-items-center">
            <label className="me-2 w-25 small">{t("welayat")}:</label>
            <select
              className="form-select"
              value={region}
              onChange={(e) => {
                setRegion(e.target.value);
                setCity("");
              }}
            >
              <option value="">{t("hemmesi")}</option>
              {uniqueRegions.map((reg) => (
                <option key={reg} value={reg}>
                  {reg}
                </option>
              ))}
            </select>
          </div>
          <div className="col d-flex align-items-center">
            <label className="me-2 w-25 small">{t("saher")}:</label>
            <select
              className="form-select"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            >
              <option value="">{t("hemmesi")}</option>
              {filteredCities.map((cty) => (
                <option key={cty} value={cty}>
                  {cty}
                </option>
              ))}
            </select>
          </div>
          {!fixedStatus && (
            <div className="col d-flex align-items-center">
              <label className="me-2 w-25 small">{t("yagdayy")}:</label>
              <select
                className="form-select"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">{t("hemmesi")}</option>
                <option value="Garaşylýar">{t("garasylyar")}</option>
                <option value="Kabul edilen">{t("kabul_edilen")}</option>
                <option value="Iberildi ýolda">{t("iberildi_yolda")}</option>
                <option value="Tamamlandy">{t("tamamlandy")}</option>
                <option value="Ret edilen">{t("ret_edilen")}</option>
              </select>
            </div>
          )}
          <div className="col d-flex align-items-center gap-2">
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="col d-flex align-items-center">
  <label className="me-2 w-25 small">{t("wagty")}:</label>
  <select
    className="form-select"
    value={time}
    onChange={(e) => setTime(e.target.value)}
  >
    <option value="">{t("hemmesi")}</option>
    {formattedOrderTimes.map((timeSlot) => (
      <option key={timeSlot} value={timeSlot}>
        {timeSlot}
      </option>
    ))}
  </select>
</div>
          <div className="col d-flex align-items-center">
            <label className="me-2 w-25 small">{t("toleg")}:</label>
            <select
              className="form-select"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
            >
              <option value="">{t("hemmesi")}</option>
              <option value="nagt">{t("nagt")}</option>
              <option value="kart">{t("kart")}</option>
              <option value="online">{t("online")}</option>
            </select>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-8 d-flex align-items-center">
            <label className="me-3 small">{t("gozleg")}:</label>
            <input
              className="form-control"
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder={t("gozleg")}
            />
          </div>
          <div className="col-4 d-flex align-items-center gap-2">
            <button
              className={`btn ${
                viewMode === "card" ? "bg-success" : "bg-secondary"
              } text-white w-100`}
              onClick={() => setViewMode("card")}
            >
              <i className="bi bi-cart"></i>
            </button>
            <button
              className={`btn ${
                viewMode === "table" ? "bg-success" : "bg-secondary"
              } text-white w-100`}
              onClick={() => setViewMode("table")}
            >
              <i className="bi bi-list"></i>
            </button>
            <button
              className="btn bg-primary text-white w-100"
              onClick={handleClear}
            >
              <i className="bi bi-eraser-fill"></i>
            </button>
          </div>
        </div>

        {viewMode === "card" ? (
          <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-2">
            {currentOrders.map((order) => (
              <div
                key={order.id}
                className="col"
                onClick={() => navigate(`/admin/home/orders/${order.id}`)}
              >
                <div
                  className={`card p-2 h-100 ${getStatusColor(order.status)}`}
                  style={{ fontSize: "14px", cursor: "pointer" }}
                >
                  <div className="d-flex justify-content-between">
                    <span>№</span>
                    <span>{order.id}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>{t("telefon_belgisi")}</span>
                    <span>{order.phone_number}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>{t("yagdayy")}</span>
                    <span>{getStatusDisplay(order.status)}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>{t("toleg_gornusi")}</span>
                    <span>{getPaymentDisplay(order.payment_method)}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>{t("barmaly_wagty")}</span>
                    <span>{order.time}</span>
                  </div>
                  <div className="d-flex justify-content-between">
                    <span>{t("doredilen_senesi")}</span>
                    <span>{formatDateTime(order.created_at)}</span>
                  </div>
                  <div className="d-flex justify-content-between fw-bold">
                    <span>{t("jemi")}</span>
                    <span>
                      {(
                        Number(order.total_price || 0) +
                        Number(order.delivery_price || 0)
                      ).toFixed(2)}{" "}
                      m
                    </span>
                  </div>
                  {order.paid_amount !== null &&
                    order.paid_amount !== undefined && (
                      <div className="d-flex justify-content-between">
                        <span>{t("berlen_pul")}</span>
                        <span>{Number(order.paid_amount).toFixed(2)} m</span>
                      </div>
                    )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-sm table-striped table-hover small">
              <thead>
                <tr>
                  <th>№</th>
                  <th>{t("telefon")}</th>
                  <th>{t("yagdayy")}</th>
                  <th>{t("toleg")}</th>
                  <th>{t("doredilen_senesi")}</th>
                  <th>{t("jemi_bahasy")}</th>
                  <th>{t("berlen_pul")}</th>
                </tr>
              </thead>
              <tbody>
                {currentOrders.map((order) => (
                  <tr
                    key={order.id}
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/admin/home/orders/${order.id}`)}
                  >
                    <td>{order.id}</td>
                    <td>{order.phone_number}</td>
                    <td>{getStatusDisplay(order.status)}</td>
                    <td>{getPaymentDisplay(order.payment_method)}</td>
                    <td>{formatDateTime(order.created_at)}</td>
                    <td>
                      {(
                        Number(order.total_price || 0) +
                        Number(order.delivery_price || 0)
                      ).toFixed(2)}{" "}
                      m
                    </td>
                    <td>
                      {order.paid_amount !== null &&
                      order.paid_amount !== undefined
                        ? `${Number(order.paid_amount).toFixed(2)} m`
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {filteredOrders.length > 0 && (
          <ProductsPagination
            currentPage={currentPage}
            onPageChange={setCurrentPage}
            totalPages={Math.ceil(filteredOrders.length / ordersPerPage)}
          />
        )}
      </div>
    </div>
  );
}
